export default __webpack_public_path__ + "static/media/logo-horizontal.a77bd78e.png";